<template>
    <div>
            <div style="xianshi">
                <div>
                    <el-cascader ref="refCascader" placeholder="请选择车型" :options="chexingSlectOption"  size="200" style="width: 400px;"
                        v-model="chengxingUidSelected" @change="change()" filterable></el-cascader>
                </div>
            </div>
        <!-- </el-card> -->
    </div>
</template>
<script>

export default {
    props: [
    'chexing_uid_props'  
  ],
    data() {
        return {
            chengxingUidSelected: 0,
            queryInfo: {
                //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
                C_type: 'get_list',
                C_table_name: 'car_type_list',
                query: '',
                pageNum: 1,
                pageSize: 10
            },
            carTypeList: [],
            // 用于下拉框的数据读取
            total: 0,
            chexingSlectOption: [],
            carTypeTishi: '' 
        }
    },
    created() {
        this.chengxingUidSelected = this.chexing_uid_props // 直接对父级传过来的参数赋值，用于打开修改界面显示的效果不一样，操作保存的query字符不一样
        // this.getcarTypeList()
          this.chexingSelect_list()
    },
    updated() {
        this.chengxingUidSelected = this.chexing_uid_props
       // console.log(9985, this.chexing_uid_props)
    },
    methods: {
        change(data) {
            const areaTextArr = []
            const areaTextArr2 = []
            // const arr = this.$refs.refCascader.getCheckedNodes()[0].pathNodes;
            
            // this.carTypeSelectedUid = arr[3].value
            // this.carTypeTishi = '当前选择：' + '[' + arr[0].label + ']' + '[' + arr[1].label + ']' + '[' + arr[2].label + ']' + '[' + arr[3].label + ']'
            // this.getCarTypeSelectedUid(this.carTypeSelectedUid)
            // console.log('carTypeSelectedUid', this.carTypeSelectedUid)
              this.$emit('getCarTypeSelectedUid', this.chengxingUidSelected[3]) 
        },
        change_(data) {
            const areaTextArr = []
            const areaTextArr2 = []
            const arr = this.$refs.refCascader.getCheckedNodes()[0].pathNodes;
            // arr.forEach((i) => {
            //     areaTextArr.push(i.label) 
            //     areaTextArr2.push(i.value) 
            // });
            // console.log(areaTextArr) 
           //  console.log(arr[3].value)
            this.carTypeSelectedUid = arr[3].value
            this.carTypeTishi = '当前选择：' + '[' + arr[0].label + ']' + '[' + arr[1].label + ']' + '[' + arr[2].label + ']' + '[' + arr[3].label + ']'
            // this.getCarTypeSelectedUid(this.carTypeSelectedUid)
            console.log('carTypeSelectedUid', this.carTypeSelectedUid)
            this.$emit('getCarTypeSelectedUid', this.carTypeSelectedUid)
            this.$emit('getCarTypeSelectedUid000', 998)
        },
        async chexingSelect_list() {
            var type = 0
            if (window.sessionStorage.getItem('tokenUserType') === '2') type = 2
            if (window.sessionStorage.getItem('tokenUserType') === '1') type = 1
            const { data: res } = await this.$http.get('get_api', {
                params: {
                    C_type: 'chexingSelect_list',
                    type: type
                }
            });
            // console.log(998, JSON.parse(res.data)[0].data)
            this.chexingSlectOption = JSON.parse(res.data)[0].data
        },

        async getcarTypeList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
           //  console.log(999, JSON.parse(res.data))
            this.carTypeList = JSON.parse(res.data)[0].dataList;
            if (!this.carTypeList) return;
            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total);
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
           // this.getcarTypeList();
           this.chexingSelect_list()
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
}

.el_row_two {
    margin-top: 30px;
}

.xianshi {
    width: 900px;
    display: flex;
    flex-direction:column;
    justify-content: space-between;
    
}</style>
